const objectHaveOnlyUndefinedProperties = (obj: object): boolean => {
	let haveValue = true;

	Object.values(obj).forEach(value => {
		if (value) haveValue = false;
	});

	return haveValue;
};
export default objectHaveOnlyUndefinedProperties;
